import { render } from "./Opco.vue?vue&type=template&id=39413f3b&scoped=true"
import script from "./Opco.vue?vue&type=script&lang=js"
export * from "./Opco.vue?vue&type=script&lang=js"

import "./Opco.vue?vue&type=style&index=0&id=39413f3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39413f3b"]])

export default __exports__